<template>
  <Row class-name="bodys" :style="{ 'min-height': `${$store.state.init.offsetHeight - 251}px` }">
    <Col span="24">
    <Breadcrumb separator=">">
      <BreadcrumbItem to="home">首页</BreadcrumbItem>
      <BreadcrumbItem :to="{
        name: 'news',
        query: { type }
      }">
        {{ menuItem[type] }}
      </BreadcrumbItem>
      <BreadcrumbItem>内容</BreadcrumbItem>
    </Breadcrumb>
    </Col>
    <Col span="24">
    <Spin fix v-if="loading" />
    <template v-else>
      <p class="title">{{ date.title }}</p>
      <p class="vice">发布时间：{{ date.date }}</p>
      <div class="editor content" v-html="date.content"></div>
    </template>
    </Col>
  </Row>
</template>

<script>
import { GetNewsinfoByID } from '@api'
import { formatDate } from '@libs/util'
export default {
  name: 'news-content',
  data() {
    return {
      date: {},
      loading: false,
      infoId: '',
      type: ''
    }
  },
  computed: {
    menuItem() {
      const { cardTitle } = window.config
      return {
        3: cardTitle[0],
        2: cardTitle[1]
      }
    }
  },
  mounted() {
    const { type, id } = this.$route.query
    this.infoId = id
    this.type = type
    this.getContent()
  },
  methods: {
    async getContent() {
      this.loading = true
      try {
        const query = { ID: this.infoId }
        const { data: { NEWSTITLE, NEWSDATETIME, NEWSNOTE } } = await GetNewsinfoByID(query)
        this.date = {
          title: NEWSTITLE,
          date: formatDate(NEWSDATETIME),
          content: NEWSNOTE
        }
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@theme/globle.scss';
$xs: 576px;

.bodys {
  background: #fff;
  padding: 16px;
  border-top: 2px solid $default;
  min-height: calc(100% - 235px);
}

.title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-top: 15px;

  @media screen and (max-width: $xs) {
    font-size: 18px;
  }
}

.vice {
  text-align: center;
  font-size: 12px;
  margin: 25px 0;
}

.content {
  font-size: 16px;
}
</style>
